export default __webpack_public_path__ + "static/media/minus.bd0b6ad1.svg";